import React, { Fragment } from "react";
import { withCookies } from "react-cookie";
import { withRouter } from "react-router-dom";
import Traductor from "../components/Traductor";
import ScrollToTop from "../components/ScrollToTop";

const CookiesPolicyPage = () => {
  const t = new Traductor();

  return (
    <Fragment>
      <ScrollToTop></ScrollToTop>
      <div
        className="c-hero-teaser c-hero-teaser--no-image c-hero-teaser--auto"
        data-testid="cookiesPolicyPageTestId"
      >
        <div className="c-hero-teaser__image"></div>
        <div id="js-hero-teaser-content" className="c-hero-teaser__content">
          <div className="c-hero-teaser__content-inner">
            <header className="c-hero-teaser__heading">
              <div className="c-hero-teaser__title">
                <h1>
                  <span className="c-hero-teaser__title-row">
                    {t.getTraduction("CookiesPolicy")}
                  </span>
                  <br />
                </h1>
              </div>
            </header>
          </div>
        </div>
      </div>

      <main className="o-main  ">
        <section className="o-content-section  u-pt-none">
          <div className="o-page-wrap  o-page-wrap--xxsmall">
            <p>
              Con la finalidad de poder ofrecer nuestros servicios, analizar los
              hábitos de navegación de los usuarios y obtener información
              estadística sobre la navegación efectuada, VWFS utiliza "cookies"
              en sus páginas web.
            </p>
            <p className="backspace-minus">&nbsp;</p>
            <p>
              <strong> ¿Qué son las “cookies”? </strong>
            </p>
            <p>
              Una cookie es un fichero que se descarga en su ordenador al
              acceder a determinadas páginas web. Las cookies permiten a una
              página web, entre otras cosas, almacenar y recuperar información
              sobre los hábitos de navegación de un usuario o de su equipo, en
              este caso, de forma anónima. Se pueden utilizar también para medir
              la audiencia, parámetros del tráfico y navegación, tiempo de
              sesión, y/o controlar el progreso y el número de entradas.
            </p>
            <p>
              Como se ha indicado, las cookies ofrecen información sobre los
              hábitos de navegación de los usuarios y en consecuencia pueden
              afectar a la privacidad de los mismos, por este motivo, queremos
              ofrecerte la información necesaria sobre la tipología de cookies
              utilizada en nuestra página web, para que tengas plena capacidad
              de decisión en relación al uso de las mismas y en relación a la
              protección de tu privacidad.
            </p>
            <p>
              En este sentido, te informamos de que para poder utilizar la
              totalidad de servicios y funcionalidades de la web es necesario
              habilitar las cookies en el navegador de Internet.
            </p>
            <p className="backspace-minus">&nbsp;</p>
            <p>
              <strong> ¿Qué&nbsp;tipos de “cookies” utilizamos?&nbsp; </strong>
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <h5> Cookies propias </h5>
            <p>
              {" "}
              (i) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <strong> Cookies necesarias (técnicas) </strong>
            </p>
            <p>
              {" "}
              Última conexión del usuario para navegar por las webs y portales
              de VWFS y utilizar sus diferentes opciones o servicios. Nunca se
              utilizarán para recopilar información con el objetivo de mostrarte
              publicidad personalizada.{" "}
            </p>
            <p>
              Un identificador de usuario por sesión, la fecha y hora de la
              última conexión del usuario y los parámetros necesarios para
              navegar entre la web de empresas y la de particulares.
            </p>
            <p>
              {" "}
              (ii) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <strong> Cookies de personalización </strong>
            </p>
            <p>
              {" "}
              Son aquellas que permiten recordar información para que el usuario
              acceda al servicio con determinadas características que pueden
              diferenciar su experiencia de la de otros usuarios, como, por
              ejemplo, el idioma, el número de resultados a mostrar cuando el
              usuario realiza una búsqueda, el aspecto o contenido del servicio
              en función del tipo de navegador a través del cual el usuario
              accede al servicio o de la región desde la que accede al servicio,
              etc.{" "}
            </p>
            <p>
              {" "}
              (iii) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <strong> Cookies de análisis </strong>
            </p>
            <p>
              {" "}
              Sirven para analizar los hábitos de navegación de los usuarios,
              con el objetivo de optimizar las funcionalidades y el
              mantenimiento técnico y operativo de las webs y portales de VWFS y
              garantizar el mejor servicio posible. Nunca se utilizarán para
              mostrar anuncios personalizados, ni para recordar las preferencias
              del usuario más allá de la sesión.{" "}
            </p>
            <p>
              {" "}
              Perfil tecnológico del dispositivo, origen del acceso a la web,
              actividad de navegación y términos de búsqueda utilizados.{" "}
            </p>
            <p>
              {" "}
              (iv) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <strong> Cookies de publicidad de marketing </strong>
            </p>
            <p>
              {" "}
              Son aquellas que permiten almacenar información del comportamiento
              de los usuarios obtenida a través de la observación continuada de
              sus hábitos de navegación, lo que permite desarrollar un perfil
              específico de usuario. De esta manera, se utilizan para
              personalizar las campañas publicitarias que se ajusten a las
              preferencias del usuario.{" "}
            </p>
            <p>&nbsp;</p>

            <h5> Cookies de terceros </h5>
            <p>
              {" "}
              <strong> Las cookies de terceros </strong> son las administradas
              por prestadores de servicios técnicos, de análisis, redes
              sociales, de personalización y de publicidad (incluida publicidad
              comportamental) ajenos a VWFS.{" "}
            </p>
            <p>
              {" "}
              (i) &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;
              <strong> Cookies de publicidad </strong>
            </p>
            <p>
              {" "}
              En determinadas ocasiones podemos ofrecer a través de nuestra
              página Web contenidos de terceros, por ejemplo, en la red de
              display de google. Éstos terceros pueden instalar cookies que
              escapan de nuestro control.{" "}
            </p>
            <p className="backspace-minus">&nbsp;</p>

            <p>
              <strong> Gestión de las "cookies" </strong>
            </p>
            <p>
              {" "}
              Teniendo en cuenta la información facilitada a través de la
              presente Política de cookies, a continuación, podrás gestionar qué
              cookies permites instalar.{" "}
            </p>

            <p>
              <strong> Cómo visualizar las "cookies" </strong>
            </p>
            <p>
              {" "}
              Todos los navegadores ofrecen al usuario la posibilidad de buscar
              y visualizar las cookies que instala un determinado sitio web,
              obtener información relativa a la duración de las mismas y la
              posibilidad de eliminarlas, tal y como se indica en el siguiente
              apartado. A continuación, se muestran una serie de enlaces
              informativos sobre esta cuestión de los navegadores más
              utilizados:{" "}
            </p>
            <p>&nbsp;</p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Google Chrome:{" "}
              <a
                href="https://support.google.com/chrome/answer/95647?hl=es"
                target="_self"
              >
                {" "}
                https://support.google.com/chrome/answer/95647?hl=es{" "}
              </a>
            </p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Mozilla Firefox:{" "}
              <a
                href="https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-webguardan-en-"
                target="_self"
              >
                {" "}
                https://support.mozilla.org/es/kb/cookies-informacion-que-los-sitios-webguardan-en-{" "}
              </a>
            </p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Internet Explorer:{" "}
              <a
                href="http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-ininternet-explorer-9"
                target="_self"
              >
                {" "}
                http://windows.microsoft.com/es-es/windows7/how-to-manage-cookies-ininternet-explorer-9{" "}
              </a>
            </p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Safari:{" "}
              <a
                href="https://www.apple.com/legal/privacy/es/cookies/ "
                target="_self"
              >
                {" "}
                https://www.apple.com/legal/privacy/es/cookies/{" "}
              </a>
            </p>
            <p>&nbsp;</p>

            <p>
              <strong> Cómo eliminar las "cookies" </strong>
            </p>
            <p>
              {" "}
              Para restringir o bloquear las cookies, deberás modificar la
              configuración del navegador que utilices en tu terminal, ya sea
              ordenador, smartphone o tablet. Con carácter general, los
              navegadores ofrecen las siguientes opciones de configuración en
              relación con la instalación de cookies:{" "}
            </p>
            <p>
              {" "}
              1. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Que el navegador rechace
              todas las cookies y, por lo tanto, que no se instale ninguna
              cookie de ninguna página web en tu terminal.{" "}
            </p>
            <p>
              {" "}
              2. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Que el navegador te avise
              antes de que se produzca la instalación de la cookie para que
              decidas si aceptas o no la instalación de la misma.{" "}
            </p>
            <p>
              {" "}
              3. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Que el navegador únicamente
              rechace las cookies de terceros de los sitios web que visita, pero
              no las utilizadas por el sitio web por el que navegas.
            </p>
            <p>
              {" "}
              4. &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;La opción de navegación en
              modo privado mediante la cual las cookies se instalan en el
              terminal, pero se eliminan de manera automática cuando finalizas
              la navegación por la página web:
            </p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Google Chrome:{" "}
              <a
                href="https://support.google.com/chrome/answer/95464?hl=es"
                target="_self"
              >
                {" "}
                https://support.google.com/chrome/answer/95464?hl=es{" "}
              </a>
            </p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Mozilla Firefox:{" "}
              <a
                href="https://support.mozilla.org/es/kb/navegacion-privada-navega-en-laweb-sin-guardar-in?redirectlocale=enUS&as=u&redirectslug=Private+Browsing&utm_source=inproduct"
                target="_self"
              >
                {" "}
                https://support.mozilla.org/es/kb/navegacion-privada-navega-en-laweb-sin-guardar-in?redirectlocale=enUS&as=u&redirectslug=Private+Browsing&utm_source=inproduct{" "}
              </a>
            </p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Internet Explorer:{" "}
              <a
                href=": http://windows.microsoft.com/es-ES/windows-8/help-protectyourself-ie-10?ocid=IE10_priv_browsing#firstTabControl=tab1"
                target="_self"
              >
                {" "}
                :
                http://windows.microsoft.com/es-ES/windows-8/help-protectyourself-ie-10?ocid=IE10_priv_browsing#firstTabControl=tab1{" "}
              </a>
            </p>
            <p>
              {" "}
              · &nbsp; &nbsp; &nbsp; &nbsp; &nbsp;Safari:{" "}
              <a href="https://www.apple.com/legal/privacy/es/" target="_self">
                {" "}
                https://www.apple.com/legal/privacy/es/{" "}
              </a>
            </p>
            <p>&nbsp;</p>

            <p>
              {" "}
              Ten en cuenta que, si se impide la instalación de todas las
              cookies de la página web, algunas funcionalidades de la misma, así
              como algunos contenidos pueden verse afectados.{" "}
            </p>
            <p>
              {" "}
              Puede ocurrir que algunas cookies utilizadas en este sitio Web no
              estén relacionadas con la Entidad. Ello se debe a que algunas
              páginas del sitio web tienen insertado contenido procedente de
              webs de terceras partes (como, por ejemplo, un vídeo de YouTube).
              Debido a que el referido contenido procede de otra web, la Entidad
              no controla la configuración de dichas cookies. Si quieres cambiar
              tus preferencias de configuración de cookies, deberás consultar
              los sitios web de dichas terceras partes para obtener información.{" "}
            </p>
            <p>
              {" "}
              Te informamos que tienes la posibilidad de revocar en cualquier
              momento el consentimiento prestado para la utilización de cookies
              por parte de la Entidad, configurando para ello su navegador en
              los términos previstos en el punto anterior o en el panel de
              Configuración de las cookies.{" "}
            </p>
            <p>&nbsp;</p>

            <p>
              <strong>
                {" "}
                Actualizaciones y cambios en la política de “cookies”{" "}
              </strong>
            </p>
            <p>
              {" "}
              La Entidad podrá modificar la Política de Cookies total o
              parcialmente, publicando cualquier cambio en la misma forma en que
              aparece esta política o a través de cualquier tipo de comunicación
              dirigida a los usuarios, en función de exigencias legislativas,
              reglamentarias o con la finalidad de adaptar dicha política a las
              instrucciones de la Agencia Española de Protección de Datos. Por
              ello, te aconsejamos la visita periódica a su contenido.{" "}
            </p>

            <p>&nbsp;</p>
            <p>Última fecha de actualización: 2 diciembre 2019</p>
            <p>&nbsp;</p>
            <p>&nbsp;</p>
          </div>
        </section>
      </main>
    </Fragment>
  );
};
export default withCookies(withRouter(CookiesPolicyPage));
